import { render } from "./SummaryByType.vue?vue&type=template&id=26619baa"
import script from "./SummaryByType.vue?vue&type=script&lang=js"
export * from "./SummaryByType.vue?vue&type=script&lang=js"
script.render = render

export default script